export default {
  ERROR: '@k-share/user/ERROR',
  USER_GET: '@k-share/user/USER_GET',
  USER_SET: '@k-share/user/USER_SET',
  USER_SEND_NOTIFICATION: '@k-share/user/USER_SEND_NOTIFICATION',
  USER_NOTIFICATION_OK: '@k-share/user/USER_NOTIFICATION_OK',
  USER_NOTIFICATION_ERROR: '@k-share/user/USER_NOTIFICATION_ERORR',
};
